const PATH = '/dividends';

export default {
    async getDividends(query) {

        return axios.get(`${PATH}/`, {params: query});
    }
}
